import Box from '@zenbusiness/zui/Box';
import ButtonBase from '@zenbusiness/zui/ButtonBase';
import { styled } from '@zenbusiness/zui/styles';

import { SmartLink } from '#client/components/SmartLink';

const baseFauxStyles = () => ({
  bottom: 0,
  height: '100%',
  left: 0,
  opacity: 0,
  overflow: 'hidden',
  position: 'absolute',
  right: 0,
  top: 0,
  width: '100%'
});

export const FauxLink = styled(SmartLink)(() => ({
  ...baseFauxStyles()
}));

export const FauxButton = styled(ButtonBase)(() => ({
  ...baseFauxStyles()
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minWidth: '3rem',
  width: '3rem',

  [theme.breakpoints.up('md')]: {
    width: '5rem'
  }
}));
